// src/components/layout/MainLayout.jsx
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

const MainLayout = () => {
    const location = useLocation();
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="mt-10 flex-grow">
        <Outlet />
      </main>
    {location.pathname !== '/viewcusproject' && <Footer />}
    </div>
  );
};

export default MainLayout;
